
            const data = {"name":"chevron-down","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M30 48.82l-29-29 8.64-8.63L30 31.54l20.36-20.36L59 19.81z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                